
import dayjs from 'dayjs'

export default {
    token: ''
}

export const shortcuts = [
    {
        text: '今天',
        value: ():Date[] => {
            const start = new Date()
            return [start, start]
        }
    },
    {
        text: '最近7天',
        value: ():Date[] => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
        }
    },
    {
        text: '最近30天',
        value: ():Date[] => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
        }
    },
    {
        text: '最近90天',
        value: ():Date[] => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
        }
    }
]
export const shortcutsNew = [
    {
        text: '今天',
        value: ():Date[] => {
            const start = new Date()
            return [start, start]
        }
    },
    {
        text: '昨天',
        value: ():Date[] => {
            const start = new Date()
            start.setDate(start.getDate() - 1); // 前一天
            start.setHours(0, 0, 0, 0); // 00:00:00
            const end = new Date(start); // 结束时间与开始时间相同
            return [start, end]
        }
    },
    {
        text: '本周',
        value: ():Date[] => {
            const today = new Date();
            const dayOfWeek = today.getDay(); // 获取今天是本周的第几天（0 是周日，1 是周一，...）
            const start = new Date(today);
            start.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)); // 本周一
            start.setHours(0, 0, 0, 0); // 00:00:00
            const end = new Date(start);
            end.setDate(start.getDate() + 6); // 本周日
            end.setHours(0, 0, 0, 0); // 00:00:00
            return [start, end];
        }
    },
    {
        text: '上周',
        value: ():Date[] => {
            const today = new Date();
            const dayOfWeek = today.getDay(); // 获取今天是本周的第几天（0 是周日，1 是周一，...）
            const thisWeekStart = new Date(today);
            thisWeekStart.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)); // 本周一
            thisWeekStart.setHours(0, 0, 0, 0); // 00:00:00
            const start = new Date(thisWeekStart);
            start.setDate(thisWeekStart.getDate() - 7); // 上周一
            start.setHours(0, 0, 0, 0); // 00:00:00
            const end = new Date(start);
            end.setDate(start.getDate() + 6); // 上周日
            end.setHours(0, 0, 0, 0); // 00:00:00
            return [start, end];
        }
    },
    {
        text: '本月',
        value: ():Date[] => {
            const start = new Date();
            start.setDate(1); // 本月第一天
            start.setHours(0, 0, 0, 0); // 00:00:00
            const end = new Date(start);
            end.setMonth(start.getMonth() + 1, 0); // 下个月的第 0 天，即本月最后一天
            end.setHours(0, 0, 0, 0); // 00:00:00
            return [start, end];
        }
    },
    {
        text: '上月',
        value: ():Date[] => {

            const thisMonthStart = new Date();
            thisMonthStart.setDate(1); // 本月第一天
            thisMonthStart.setHours(0, 0, 0, 0); // 00:00:00
            const start = new Date(thisMonthStart);
            start.setMonth(thisMonthStart.getMonth() - 1, 1); // 上月第一天
            start.setHours(0, 0, 0, 0); // 00:00:00
            const end = new Date(start);
            end.setMonth(start.getMonth() + 1, 0); // 上月的最后一天
            end.setHours(0, 0, 0, 0); // 00:00:00
            return [start, end];
        }
    },
]
